import styled from "styled-components";

// eslint-disable-next-line import/prefer-default-export
export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  grid-gap: ${(props) => props.gridgap ?? "12px"};
`;
